import { useEffect, useState } from 'react';

import { NAV_LINKS, WHATSAPP_MESSAGES } from '../../core/constants/site';
import { buildWhatsAppUrl } from '../../core/utils/whatsapp';
import { IconClose, IconMenu, IconWhatsApp } from '../../common/icons';
import BrandMark from '../../common/components/BrandMark/BrandMark';

import './styles/site-header.css';

const SCROLLED_THRESHOLD_PX = 16;

export default function SiteHeader() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > SCROLLED_THRESHOLD_PX);
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (!isMenuOpen) return undefined;

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') setIsMenuOpen(false);
        };
        document.addEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = '';
        };
    }, [isMenuOpen]);

    const closeMenu = () => setIsMenuOpen(false);
    const headerClasses = [
        'site-header',
        isScrolled || isMenuOpen ? 'site-header--solid' : '',
    ].filter(Boolean).join(' ');

    return (
        <header className={headerClasses}>
            <div className="site-header__inner container">
                <BrandMark onClick={closeMenu} />

                <nav
                    id="site-navigation"
                    className={`site-header__nav ${isMenuOpen ? 'site-header__nav--open' : ''}`.trim()}
                    aria-label="Principal"
                >
                    <ul className="site-header__list">
                        {NAV_LINKS.map(link => (
                            <li key={link.href}>
                                <a className="site-header__link" href={link.href} onClick={closeMenu}>
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="site-header__actions">
                    <a
                        className="button button--whatsapp button--compact site-header__whatsapp"
                        href={buildWhatsAppUrl(WHATSAPP_MESSAGES.quote)}
                        target="_blank"
                        rel="noopener"
                    >
                        <IconWhatsApp size={18} />
                        <span className="site-header__whatsapp-label">WhatsApp</span>
                    </a>

                    <button
                        type="button"
                        className="site-header__toggle"
                        aria-expanded={isMenuOpen}
                        aria-controls="site-navigation"
                        onClick={() => setIsMenuOpen(current => !current)}
                    >
                        <span className="sr-only">{isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}</span>
                        {isMenuOpen ? <IconClose /> : <IconMenu />}
                    </button>
                </div>
            </div>
        </header>
    );
}
